import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import { TooltipProvider } from '@/components/ui/tooltip';
import { Toaster } from '@/components/ui/toaster';
import { Toaster as Sonner } from '@/components/ui/sonner';

import { store } from '../store';
import { router } from './router';

export const AppProvider = () => (
  <Provider store={store}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <RouterProvider router={router} />
    </TooltipProvider>
  </Provider>
);
